<template>
  <div>
    <div class="header">
      <div class="container-fluid">

        <b-row class="align-items-center mt-3 mb-2">
          <b-col>
            <span class="text-muted" v-if="comunasFiltradas.length !== comunas.length">
              {{ comunasFiltradas.length }} / {{ comunas.length }} {{ $t('mant_comunas') }}
            </span>
            <span class="text-muted" v-else>{{ comunas.length }} {{ $t('mant_comunas') }}</span>
          </b-col>
          <b-col class="text-right">
            <button class="btn btn-sm btn-success mr-2" @click="exportarExcel" :disabled="!comunasFiltradas.length" :title="$t('exportar_excel')">
              <i class="fas fa-file-excel mr-1" aria-hidden="true"></i>
              XLS
            </button>
            <router-link v-if="puedeEditar" :to="regionFiltro ? { name: 'comuna-crear', query: { region: regionFiltro } } : { name: 'comuna-crear' }">
              <b-button variant="primary" size="sm">
                <i class="ni ni-fat-add mr-1"></i> {{ $t('crear_comuna') }}
              </b-button>
            </router-link>
          </b-col>
        </b-row>

        <div v-if="regionFiltro" class="alert alert-info d-flex justify-content-between align-items-center py-2">
          <span>{{ $t('filtrando_por_region') }}: <strong>{{ regionFiltroNombre || regionFiltro }}</strong></span>
          <router-link :to="{ name: 'comunas' }">
            <b-button variant="outline-secondary" size="sm">{{ $t('ver_todas') }}</b-button>
          </router-link>
        </div>

        <b-alert variant="danger" :show="!!error" dismissible @dismissed="error = ''">
          {{ error }}
        </b-alert>

        <div v-if="cargando" class="text-center text-muted mt-5">
          <b-spinner variant="primary" />
        </div>

        <div v-else-if="comunas.length" class="card shadow" style="margin-bottom: 60px;">
          <div class="tabla-scroll-fixed" ref="tablaComunas">
            <table class="table table-hover align-items-center mb-0">
              <thead class="thead-sticky thead-light">
                <tr>
                  <th class="th-ordenable" @click="ordenarPor('nombre')">
                    <input class="th-search-input" v-model="filterCol.nombre" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('nombre') }} <i :class="iconoOrden('nombre')"></i></span>
                  </th>
                  <th class="th-ordenable" @click="ordenarPor('regionNombre')">
                    <input class="th-search-input" v-model="filterCol.region" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('region') }} <i :class="iconoOrden('regionNombre')"></i></span>
                  </th>
                  <th class="th-ordenable" style="min-width:160px;" @click="ordenarPor('paisNombre')">
                    <input class="th-search-input" v-model="filterCol.pais" @click.stop :placeholder="$t('buscar')" />
                    <span class="th-label">{{ $t('pais') }} <i :class="iconoOrden('paisNombre')"></i></span>
                  </th>
                  <th style="width:160px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in comunasPaginadas" :key="c.idComuna">
                  <td>{{ c.nombre }}</td>
                  <td>{{ c.regionNombre || '-' }}</td>
                  <td>{{ c.paisNombre || '-' }}</td>
                  <td class="text-center">
                    <router-link :to="{ name: 'comuna-detalle', params: { id: c.idComuna } }">
                      <b-button size="sm" variant="outline-primary" class="mr-1">
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                    </router-link>
                    <b-button v-if="puedeEditar" size="sm" variant="outline-danger" @click="eliminarComuna(c.idComuna)">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pagination-floating-bar" v-if="comunas.length">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
            <select v-model.number="pageSize" @change="currentPage = 1" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="999999">Todas</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPages }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ comunasFiltradas.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPages" @click="currentPage++">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" title="Scroll izquierda"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" title="Scroll derecha"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" title="Ir al inicio"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" title="Ir al final"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>

        <div v-else-if="!cargando" class="text-center text-muted mt-5">
          <i class="fas fa-map-marker-alt fa-3x mb-3"></i>
          <p>{{ $t('no_hay_comunas') }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import comunaService from '@/api/comunaService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

export default {
  name: 'ComunaView',
  data() {
    return {
      comunas: [],
      regionesMap: {},
      cargando: false,
      error: '',
      ordenColumna: null,
      ordenDireccion: 'asc',
      filterCol: {
        nombre: '',
        region: '',
        pais: '',
      },
      currentPage: 1,
      pageSize: 50,
      regionFiltro: null,
      regionFiltroNombre: '',
    };
  },

  watch: {
    filterCol: { deep: true, handler() { this.currentPage = 1; } },
    '$route.query.region'(nuevo) {
      this.regionFiltro = nuevo || null;
      this.cargarComunas();
    },
  },

  mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    this._scrollHandler = this._onWindowScroll.bind(this);
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    this.regionFiltro = this.$route.query.region || null;
    this.cargarComunas();
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._scrollHandler);
  },

  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
    comunasConRegion() {
      return this.comunas.map(c => {
        const region = this.regionesMap[c.idRegion];
        return {
          ...c,
          regionNombre: (region && region.nombre) || '',
          paisNombre: (region && region.paisNombre) || '',
        };
      });
    },
    comunasFiltradas() {
      const fc = this.filterCol;
      let lista = this.comunasConRegion;
      if (fc.nombre) lista = lista.filter(c => (c.nombre || '').toLowerCase().includes(fc.nombre.toLowerCase()));
      if (fc.region) lista = lista.filter(c => (c.regionNombre || '').toLowerCase().includes(fc.region.toLowerCase()));
      if (fc.pais) lista = lista.filter(c => (c.paisNombre || '').toLowerCase().includes(fc.pais.toLowerCase()));
      return lista;
    },
    comunasOrdenadas() {
      if (!this.ordenColumna) return this.comunasFiltradas;
      const sorted = [...this.comunasFiltradas];
      sorted.sort((a, b) => {
        let vA = a[this.ordenColumna];
        let vB = b[this.ordenColumna];
        if (vA == null) vA = '';
        if (vB == null) vB = '';
        if (typeof vA === 'number' && typeof vB === 'number') return this.ordenDireccion === 'asc' ? vA - vB : vB - vA;
        vA = String(vA).toLowerCase();
        vB = String(vB).toLowerCase();
        if (vA < vB) return this.ordenDireccion === 'asc' ? -1 : 1;
        if (vA > vB) return this.ordenDireccion === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    },
    totalPages() {
      if (this.pageSize >= 999999) return 1;
      return Math.max(1, Math.ceil(this.comunasOrdenadas.length / this.pageSize));
    },
    comunasPaginadas() {
      if (this.pageSize >= 999999) return this.comunasOrdenadas;
      const start = (this.currentPage - 1) * this.pageSize;
      return this.comunasOrdenadas.slice(start, start + this.pageSize);
    },
  },

  methods: {
    async cargarComunas() {
      this.cargando = true;
      this.error = '';
      try {
        const regiones = await comunaService.getRegionesOptions();
        const map = {};
        (regiones || []).forEach(r => { map[r.idRegion] = { nombre: r.nombre, paisNombre: r.paisNombre }; });
        this.regionesMap = map;
        this.regionFiltroNombre = this.regionFiltro ? ((map[this.regionFiltro] && map[this.regionFiltro].nombre) || '') : '';
        this.comunas = await comunaService.getAll(this.regionFiltro);
      } catch (e) {
        this.error = (e && e.response && e.response.data && e.response.data.message) || 'Ocurrió un error al cargar las comunas.';
      } finally {
        this.cargando = false;
      }
    },

    eliminarComuna(id) {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('eliminar_comuna_permanente'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await comunaService.deleteBy(id);
            this.comunas = await comunaService.getAll(this.regionFiltro);
            Swal.fire({ text: this.$t('eliminado_correctamente'), icon: 'success', timer: 2000, showConfirmButton: false });
          } catch {
            this.error = this.$t('error_eliminar_comuna');
          }
        }
      });
    },

    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
      this.currentPage = 1;
    },

    iconoOrden(columna) {
      if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollTabla(dir) {
      const el = this.$refs.tablaComunas;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    _onWindowScroll() {
      const cont = this.$refs.tablaComunas;
      if (!cont) return;
      const thead = cont.querySelector('thead.thead-sticky');
      if (!thead) return;
      const top = cont.getBoundingClientRect().top;
      thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
    },

    exportarExcel() {
      const rows = this.comunasOrdenadas;
      if (!rows.length) { Swal.fire({ icon: 'info', title: this.$t('no_filas_exportar') }); return; }

      const cols = [
        { key: 'nombre', label: this.$t('nombre') },
        { key: 'regionNombre', label: this.$t('region') },
        { key: 'paisNombre', label: this.$t('pais') },
      ];
      const header = cols.map(c => c.label);
      const data = [header, ...rows.map(r => cols.map(c => r[c.key] == null ? '' : r[c.key]))];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws['!cols'] = header.map(h => ({ wch: Math.max(10, String(h).length + 2) }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Comunas');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const fecha = new Date().toISOString().slice(0, 10);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Comunas_${fecha}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}

.card {
  border-radius: 10px;
  overflow: hidden;
}

.tabla-scroll-fixed {
  overflow-x: auto;
  position: relative;
  font-size: 0.8rem;
}

.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 12px;
}

.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}
</style>
